import script from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MainHeader.vue?vue&type=style&index=0&id=75ca6d91&lang=css"

const __exports__ = script;

export default __exports__